module.exports = "/_next/static/images/682daf3af9efed052a651a2bbfbeb4bb-Nubank_HickDuarte_57380_md.png";